import React, { useState, useEffect } from 'react';
import { useUserContext } from '../context/UserContext';
import { useContractorsContext} from '../context/ContractorsContext'
import ModalWindow from '../components/ModalContractor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faPlus } from '@fortawesome/free-solid-svg-icons';

const ContractorsPage = () => {
  const { users } = useUserContext();
    const { getContractors, contractors } = useContractorsContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedContractor, setSelectedContractor] = useState(null);

    useEffect(() => {
      getContractors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const openModal = (contractor) => {
      setSelectedContractor(contractor);
      setIsModalOpen(true);
    };

    const closeModal = () => {
      setSelectedContractor(null);
      setIsModalOpen(false);
    };

    const formatName = (userId) => {
      const idx = users.findIndex((u) => u._id === userId);
      if (idx !== -1) return users[idx].name;
      return '—';
    };

    const formatDate = (date) => {
      const d = new Date(date);
      if (isNaN(d)) return '';
      return d.toLocaleString();
    };

    const formatField = (value) => value || '—';

  return (
    <div className="crm-page">
      <div className="crm-breadcrumb">
        <span className="crm-breadcrumb__item">Рабочий стол</span>
        <span className="crm-breadcrumb__sep">›</span>
        <span className="crm-breadcrumb__item crm-breadcrumb__item--active">Контрагенты</span>
      </div>

      <div className="crm-page-header">
        <h1 className="crm-page-title">
          <FontAwesomeIcon icon={faBuilding} style={{ marginRight: 10 }} />
          Контрагенты
        </h1>
        <div className="contractors-header-actions">
          <span className="contractors-count">Всего: {contractors.length}</span>
          <button className="contractors-add-btn" onClick={() => openModal(null)}>
            <FontAwesomeIcon icon={faPlus} />
            <span>Создать контрагента</span>
          </button>
        </div>
      </div>

      <div className="contractors-grid">
        {contractors.length === 0 && (
          <div className="contractors-empty">Список контрагентов пуст</div>
        )}

        {contractors.map((contractor) => (
          <article
            key={contractor._id}
            className="contractor-card"
            onClick={() => openModal(contractor)}
          >
            <header className="contractor-card__header">
              <h3 className="contractor-card__title">{formatField(contractor.name)}</h3>
            </header>

            <div className="contractor-card__meta-grid">
              <div className="contractor-card__meta-item">
                <span className="contractor-card__meta-label">Адрес</span>
                <span className="contractor-card__meta-value">{formatField(contractor.address)}</span>
              </div>
              <div className="contractor-card__meta-item">
                <span className="contractor-card__meta-label">ИНН</span>
                <span className="contractor-card__meta-value">{formatField(contractor.inn)}</span>
              </div>
              <div className="contractor-card__meta-item">
                <span className="contractor-card__meta-label">КПП</span>
                <span className="contractor-card__meta-value">{formatField(contractor.kpp)}</span>
              </div>
              <div className="contractor-card__meta-item">
                <span className="contractor-card__meta-label">Контакт</span>
                <span className="contractor-card__meta-value">{formatField(contractor.contact)}</span>
              </div>
              <div className="contractor-card__meta-item">
                <span className="contractor-card__meta-label">Телефон</span>
                <span className="contractor-card__meta-value">{formatField(contractor.phone)}</span>
              </div>
              <div className="contractor-card__meta-item">
                <span className="contractor-card__meta-label">Создал</span>
                <span className="contractor-card__meta-value">{formatName(contractor.madeBy)}</span>
              </div>
            </div>

            <footer className="contractor-card__footer">
              <span className="contractor-card__date">{formatDate(contractor.dateTime)}</span>
            </footer>
          </article>
        ))}
      </div>

      {isModalOpen && <ModalWindow contractor={selectedContractor} onClose={closeModal} />}
    </div>
  );
};

export default ContractorsPage;